module.exports = __webpack_public_path__ + "media/WR Blob 9.f9d99c4e.mp3";